import { Link, useHistory } from 'react-router-dom'

import LogoWhite from 'components/Logo'
import * as S from './styles'
import Input from 'components/Input'
import LargeButton from 'components/LargeButton'
import { useWindowSizeHook } from 'hooks/useWindowHooks'

const SignUp = () => {
  const { width } = useWindowSizeHook()
  const history = useHistory()

  return (
    <S.Wrapper>
      {width >= 794 && (
        <S.SideLeft>
          <S.Background>
            <LogoWhite size="small" />

            <S.WrapperMessage>
              <p className="message">
                All your favorite games
                <br /> in one place
              </p>
              <p className="describe">
                WON is the best and most complete gaming platform.
              </p>
            </S.WrapperMessage>
            <p className="footer-message">
              Won Games 2020 © Todos os Direitos Reservados
            </p>
          </S.Background>
        </S.SideLeft>
      )}

      <S.SideRight>
        <LogoWhite size="large" />
        <h3>Sign up</h3>
        <Input placeholder="Name" type="text" />
        <Input placeholder="Email" type="email" />
        <Input placeholder="Password" type="password" />
        <Input placeholder="Confirm password" type="password" />

        <LargeButton onClick={() => history.push('/')}>Sign up now</LargeButton>
        <Link className="link signin" to="signin">
          Already have an account? Sign in
        </Link>
      </S.SideRight>
    </S.Wrapper>
  )
}

export default SignUp
